var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDownArrow = function SvgIconDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.197 12.418a.769.769 0 0 1-.614-.3L1.01 7.607a.775.775 0 0 1-.008-1.093.762.762 0 0 1 1.093-.007l3.315 3.27L5.348.886a.766.766 0 0 1 .764-.774.762.762 0 0 1 .774.764l.062 8.905 3.276-3.322a.762.762 0 0 1 1.092-.007.76.76 0 0 1 .008 1.092l-4.568 4.632-.015.015a.766.766 0 0 1-.545.227Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconDownArrow;